module.exports = __webpack_public_path__ + "static/media/col-7.0ff5181a.png";